import { useEffect } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Icon104Telescope } from '@care/react-svg-icons';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';

export interface ExploreNoResultsProps {
  noResults: boolean;
  isNationalListPage: boolean;
  isMobileOrSmaller: boolean;
}

const ExploreNoResults = ({
  noResults,
  isMobileOrSmaller,
  isNationalListPage,
}: ExploreNoResultsProps) => {
  const { segmentNamePluralLowerCase, city, state } = usePageAttributes();

  const availableText = isNationalListPage
    ? `There are no ${segmentNamePluralLowerCase} available in your area`
    : `There are no ${segmentNamePluralLowerCase} available in ${city}, ${state}`;

  const headlineText = noResults ? 'No matches within your search' : availableText;
  const bodyText = noResults
    ? 'Sorry, we couldn’t find a good match. Try adjusting your filters or browsing other activity options.'
    : 'Try searching again in the nearest city';

  const onClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const url = isNationalListPage
      ? '/explore/d/activities'
      : globalThis.location.pathname.replace(/(\/explore\/d\/)[^/]+/, '$1activities');
    globalThis.location.href = url;

    trackAmplitudeEvent(AmplitudeEvent.seoFeatureInteracted, {
      feature_name: 'Explore other activities CTA',
    });
  };

  useEffect(() => {
    trackAmplitudeEvent(AmplitudeEvent.errorViewed, {
      error_description: 'SEO no results',
    });
  }, []);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pb: 6 }}>
      <Stack sx={{ maxWidth: 392, textAlign: 'center' }} alignItems="center" gap={2}>
        <Icon104Telescope size={200} />
        <Typography variant="h1"> {headlineText}</Typography>
        <Typography variant="body1">{bodyText}</Typography>
        {noResults && (
          <Button
            fullWidth={isMobileOrSmaller}
            color="secondary"
            component="a"
            href=""
            onClick={onClick}
            size="large"
            sx={{
              minWidth: isMobileOrSmaller ? 'auto' : '280px',
              mt: isMobileOrSmaller ? 18 : 0,
            }}
            variant="contained">
            Explore other activities
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default ExploreNoResults;
